import { Logger, select, selectAll } from "@fruugo/utilities";
import { Sku } from "../types";
import { i18n } from "./i18n";

const Log = new Logger(window.environment);

export const updateShippingCost = (
  quantity: number,
  skuInfo: Sku,
  currentCountry: string,
  currentLanguage: string
) => {
  const { id } = skuInfo;
  const shippingCostElement = select(".js-shipping-cost");

  const addToCartButton = selectAll<HTMLButtonElement>(".js-add-to-cart");
  const buyNowButton = selectAll<HTMLButtonElement>(".js-buy-now");

  if (!shippingCostElement) return;

  const updateBuyButtons = (disabled: boolean) => {
    addToCartButton.forEach((button) => (button.disabled = disabled));
    buyNowButton.forEach((button) => (button.disabled = disabled));
  };

  updateBuyButtons(false);

  fetch(
    `/marketplace/api/shipping-cost/${id}?quantity=${quantity}&country=${currentCountry}&language=${currentLanguage}`
  )
    .then((res) => res.json())
    .then((data) => {
      const { shippingCost, numericShippingCost, hasAvailableShippingMethods } =
        data;

      if (!hasAvailableShippingMethods) {
        shippingCostElement.replaceChildren(
          <span class="text-danger">
            {i18n("cart.itemnotavailable.notshippable", `/help`)}
          </span>
        );

        updateBuyButtons(true);

        return;
      }

      if (
        typeof numericShippingCost === "undefined" ||
        numericShippingCost === null
      )
        return;

      if (numericShippingCost > 0) {
        shippingCostElement.replaceChildren(
          <span class="text-muted text-nowrap">
            {i18n("product.paid.shipping", shippingCost)}
          </span>
        );
      } else {
        shippingCostElement.replaceChildren(
          <span class="font-weight-bold text-success text-nowrap">
            {i18n("product.free.shipping")}
          </span>
        );
      }
    })
    .catch((error) => Log.error(error));
};
